module.exports = __webpack_public_path__ + "aq.no1.c6fa9a9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aq.no1.jpg
// module id = 7zZF
// module chunks = 0